import React from 'react'

const Facebook = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg">
<path d="M14.4998 3C8.14868 3 3 8.16769 3 14.5422C3 19.9551 6.71305 24.4972 11.7219 25.7447V18.0696H9.35063V14.5422H11.7219V13.0224C11.7219 9.09384 13.4933 7.27294 17.3361 7.27294C18.0647 7.27294 19.3219 7.41652 19.8361 7.55965V10.7568C19.5647 10.7282 19.0932 10.7139 18.5077 10.7139C16.6222 10.7139 15.8935 11.4309 15.8935 13.2948V14.5422H19.6498L19.0045 18.0696H15.8935V26C21.5878 25.3098 26 20.4436 26 14.5422C25.9995 8.16769 20.8509 3 14.4998 3Z" fill="currentColor"></path>
</svg>
    )
}

export default Facebook
